import ItineraryModuleCard from './ItineraryModuleCard';

export default ItineraryModuleCard;
